import {AbstractSqliteDatabase} from "./abstract-sqlite.database";
import {Injectable} from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ParametersDatabase extends AbstractSqliteDatabase {

    constructor() {
        super("parameters_store", "parameters");
    }

}